import styled from "styled-components/macro";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import AheadBehindTile from "./AheadBehindTile";
import { AHEAD_BEHIND_TILE_WIDTH } from "../aheadBehindUtils";
import ProgressBar from "./ProgressBar";
import { PROGRESS_BAR_TOTAL_WIDTH } from "./ProgressBarContent";

export const SINGLE_CHART_WIDTH =
  PROGRESS_BAR_TOTAL_WIDTH + AHEAD_BEHIND_TILE_WIDTH;

type AheadBehindSummaryChartProps = {
  currentOutput: number | null;
  currentTargetOutput: number | null;
  totalTargetOutput: number | null;
  outputLossSum: number | null;
  outputLossSumColorOnly?: number | null;
  timeIntervalName: string;
  metricDisplayOverride?: string | JSX.Element | null;
};

/** Includes a ProgressBar for output relative to targets, and an AheadBehindTile for the outputLoss value */
export default function AheadBehindSummaryChart({
  currentOutput,
  currentTargetOutput,
  totalTargetOutput,
  outputLossSum,
  outputLossSumColorOnly,
  timeIntervalName,
  metricDisplayOverride,
}: AheadBehindSummaryChartProps) {
  const { translate } = useFlightTranslation();
  const timeIntervalTranslationKey =
    timeIntervalName.toLocaleLowerCase() === "hour"
      ? "Ahead_/_Behind_this_hour"
      : timeIntervalName.toLocaleLowerCase() === "shift"
        ? "Ahead_/_Behind_this_shift"
        : timeIntervalName;

  return (
    <AheadBehindSummaryChartStyles>
      <div className="intervalLabel">
        {translate(timeIntervalTranslationKey)}
      </div>
      <div className="chartData">
        <ProgressBar
          currentProgress={currentOutput}
          totalTarget={totalTargetOutput}
          currentTarget={currentTargetOutput}
        />
        <AheadBehindTile
          outputLossSum={outputLossSum}
          outputLossSumColorOnly={outputLossSumColorOnly}
          metricDisplayOverride={metricDisplayOverride}
        />
      </div>
    </AheadBehindSummaryChartStyles>
  );
}

const AheadBehindSummaryChartStyles = styled.div`
  width: ${SINGLE_CHART_WIDTH}px;
  font-family: "Open Sans";
  letter-spacing: 0.02em;
  .intervalLabel {
    margin-bottom: 20px;
    font-size: 32px;
    line-height: 34px;
    display: flex;
    justify-content: center;
  }
  .chartData {
    display: flex;
    justify-content: center;
  }
`;
